//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './CalendarConfigurationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetCalendarConfigurationCalendarConfigurationQueryParameters = {
  id: number ;
}

export type EditCalendarConfigurationCalendarConfigurationQueryParameters = {
  id: number ;
}

export type RemoveCalendarConfigurationCalendarConfigurationQueryParameters = {
  id: number ;
}

export type PinCalendarConfigurationCalendarConfigurationQueryParameters = {
  id: number ;
}

export function getCalendarConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/calendar-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCalendarConfigurationDefaultOptions: Omit<UseQueryOptions<Types.CalendarConfigurationDto, unknown, Types.CalendarConfigurationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CalendarConfigurationDto, unknown, Types.CalendarConfigurationDto>, 'queryFn'>> = {
};
export function getGetCalendarConfigurationDefaultOptions() {
  return getCalendarConfigurationDefaultOptions;
};
export function setGetCalendarConfigurationDefaultOptions(options: typeof getCalendarConfigurationDefaultOptions) {
  getCalendarConfigurationDefaultOptions = options;
}

export function getCalendarConfigurationQueryKey(id: number): QueryKey;
export function getCalendarConfigurationQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetCalendarConfigurationCalendarConfigurationQueryParameters;

    return trimArrayEnd([
        'CalendarConfigurationClient',
        'getCalendarConfiguration',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'CalendarConfigurationClient',
        'getCalendarConfiguration',
        ...params
      ]);
  }
}
export function __getCalendarConfiguration(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCalendarConfiguration(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetCalendarConfigurationQuery<TSelectData = Types.CalendarConfigurationDto, TError = unknown>(dto: GetCalendarConfigurationCalendarConfigurationQueryParameters, options?: Omit<UseQueryOptions<Types.CalendarConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a calendar configuration by id.
 * @param id Id of calendar configuration.
 */
export function useGetCalendarConfigurationQuery<TSelectData = Types.CalendarConfigurationDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.CalendarConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCalendarConfigurationQuery<TSelectData = Types.CalendarConfigurationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CalendarConfigurationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetCalendarConfigurationCalendarConfigurationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CalendarConfigurationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCalendarConfiguration(context, axiosConfig) : __getCalendarConfiguration,
    queryKey: getCalendarConfigurationQueryKey(id),
    ...getCalendarConfigurationDefaultOptions as unknown as Omit<UseQueryOptions<Types.CalendarConfigurationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a calendar configuration by id.
 * @param id Id of calendar configuration.
 */
export function setGetCalendarConfigurationData(queryClient: QueryClient, updater: (data: Types.CalendarConfigurationDto | undefined) => Types.CalendarConfigurationDto, id: number) {
  queryClient.setQueryData(getCalendarConfigurationQueryKey(id),
    updater
  );
}

/**
 * Gets a calendar configuration by id.
 * @param id Id of calendar configuration.
 */
export function setGetCalendarConfigurationDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CalendarConfigurationDto | undefined) => Types.CalendarConfigurationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editCalendarConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/calendar-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editCalendarConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CalendarConfigurationClient',
      'editCalendarConfiguration',
      id as any,
    ]);
}

export function useEditCalendarConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.CalendarConfigurationDto, unknown, Types.UpdateCalendarConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CalendarConfigurationDto, unknown, Types.UpdateCalendarConfigurationDto, TContext> {
  const key = editCalendarConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updateDto: Types.UpdateCalendarConfigurationDto) => Client.editCalendarConfiguration(id, updateDto),
    mutationKey: key,
  });
}
  
type EditCalendarConfiguration__MutationParameters = EditCalendarConfigurationCalendarConfigurationQueryParameters & {
  updateDto: Types.UpdateCalendarConfigurationDto;
}

export function useEditCalendarConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.CalendarConfigurationDto, unknown, EditCalendarConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditCalendarConfigurationCalendarConfigurationQueryParameters}): UseMutationResult<Types.CalendarConfigurationDto, unknown, EditCalendarConfiguration__MutationParameters, TContext> {
  const key = editCalendarConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditCalendarConfiguration__MutationParameters) => Client.editCalendarConfiguration(data.id ?? options?.parameters?.id!, data.updateDto),
  mutationKey: key,
});
}
  
export function removeCalendarConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/calendar-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeCalendarConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CalendarConfigurationClient',
      'removeCalendarConfiguration',
      id as any,
    ]);
}

export function useRemoveCalendarConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeCalendarConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeCalendarConfiguration(id),
    mutationKey: key,
  });
}
  
type RemoveCalendarConfiguration__MutationParameters = RemoveCalendarConfigurationCalendarConfigurationQueryParameters

export function useRemoveCalendarConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveCalendarConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveCalendarConfigurationCalendarConfigurationQueryParameters}): UseMutationResult<void, unknown, RemoveCalendarConfiguration__MutationParameters, TContext> {
  const key = removeCalendarConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveCalendarConfiguration__MutationParameters) => Client.removeCalendarConfiguration(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getCalendarConfigurationsUrl(): string {
  let url_ = getBaseUrl() + "/api/calendar-configuration";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCalendarConfigurationsDefaultOptions: Omit<UseQueryOptions<Types.CalendarConfigurationListDto[], unknown, Types.CalendarConfigurationListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CalendarConfigurationListDto[], unknown, Types.CalendarConfigurationListDto[]>, 'queryFn'>> = {
};
export function getGetCalendarConfigurationsDefaultOptions() {
  return getCalendarConfigurationsDefaultOptions;
};
export function setGetCalendarConfigurationsDefaultOptions(options: typeof getCalendarConfigurationsDefaultOptions) {
  getCalendarConfigurationsDefaultOptions = options;
}

export function getCalendarConfigurationsQueryKey(): QueryKey;
export function getCalendarConfigurationsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'CalendarConfigurationClient',
      'getCalendarConfigurations',
    ]);
}
export function __getCalendarConfigurations(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCalendarConfigurations(
axiosConfig    );
}

/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function useGetCalendarConfigurationsQuery<TSelectData = Types.CalendarConfigurationListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.CalendarConfigurationListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCalendarConfigurationsQuery<TSelectData = Types.CalendarConfigurationListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CalendarConfigurationListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CalendarConfigurationListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCalendarConfigurations(context, axiosConfig) : __getCalendarConfigurations,
    queryKey: getCalendarConfigurationsQueryKey(),
    ...getCalendarConfigurationsDefaultOptions as unknown as Omit<UseQueryOptions<Types.CalendarConfigurationListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function setGetCalendarConfigurationsData(queryClient: QueryClient, updater: (data: Types.CalendarConfigurationListDto[] | undefined) => Types.CalendarConfigurationListDto[], ) {
  queryClient.setQueryData(getCalendarConfigurationsQueryKey(),
    updater
  );
}

/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function setGetCalendarConfigurationsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CalendarConfigurationListDto[] | undefined) => Types.CalendarConfigurationListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createCalendarConfigurationUrl(): string {
  let url_ = getBaseUrl() + "/api/calendar-configuration";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createCalendarConfigurationMutationKey(): MutationKey {
  return trimArrayEnd([
      'CalendarConfigurationClient',
      'createCalendarConfiguration',
    ]);
}

export function useCreateCalendarConfigurationMutation<TContext>(options?: Omit<UseMutationOptions<Types.CalendarConfigurationDto, unknown, Types.CreateCalendarConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CalendarConfigurationDto, unknown, Types.CreateCalendarConfigurationDto, TContext> {
  const key = createCalendarConfigurationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createDto: Types.CreateCalendarConfigurationDto) => Client.createCalendarConfiguration(createDto),
    mutationKey: key,
  });
}
  
export function pinCalendarConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/calendar-configuration/pin/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function pinCalendarConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CalendarConfigurationClient',
      'pinCalendarConfiguration',
      id as any,
    ]);
}

export function usePinCalendarConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PinCalendarConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PinCalendarConfigurationDto, TContext> {
  const key = pinCalendarConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PinCalendarConfigurationDto) => Client.pinCalendarConfiguration(id, dto),
    mutationKey: key,
  });
}
  
type PinCalendarConfiguration__MutationParameters = PinCalendarConfigurationCalendarConfigurationQueryParameters & {
  dto: Types.PinCalendarConfigurationDto;
}

export function usePinCalendarConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PinCalendarConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PinCalendarConfigurationCalendarConfigurationQueryParameters}): UseMutationResult<void, unknown, PinCalendarConfiguration__MutationParameters, TContext> {
  const key = pinCalendarConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PinCalendarConfiguration__MutationParameters) => Client.pinCalendarConfiguration(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}